import { Link } from 'react-router-dom';
import type { Service } from '@shared';

export function ServiceCard({ svc }: { svc: Service }) {
  return (
    <Link to={`/services/${svc.id}`} className="svc-card-link" style={{ display: 'contents' }}>
      <div className="svc-card">
        <div className="meta">
          <span>{svc.fee}</span>
          <span className="dot" />
          <span>{svc.lead}</span>
        </div>
        <div className="name">{svc.name}</div>
        <div className="summary">{svc.summary}</div>
        <div className="arrow">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M3 7h8M7.5 3.5 11 7l-3.5 3.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      </div>
    </Link>
  );
}
